import { render, staticRenderFns } from "./ChatLogListCard.vue?vue&type=template&id=a55e2e60&"
import script from "./ChatLogListCard.vue?vue&type=script&lang=js&"
export * from "./ChatLogListCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports